module.exports = __webpack_public_path__ + "static/img/wall-pics.e1fbab72.png";